:host {
    display: block;
}

.headline {
    @include typo-ws-h4;

    margin: 0;
}

::slotted(sew-picture),
::slotted(.blog-post) {
    display: block;
    margin-top: 20px;
}

::slotted(p) {
    @include typo-ws-paragraph;

    margin-top: 16px;
}

::slotted(sew-ws-link) {
    margin-top: 20px;
    color: $color-grey-05-light;
}
